// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-76f59e32]{transition-property:all;transition-duration:.3s;transition-timing-function:linear;transform-origin:left;transform:scale(0)}.tooltip.loaded[data-v-76f59e32]{transform:scale(1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
